export const PinterestIcon = ({
  width = 24,
  height = 24,
  title = "Pinterest",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}>
      <title>{title}</title>
      <path
        fill="#F5F6F7"
        d="M12 2.04C6.5 2.04 3 5.98 3 9.27c0 2.03.77 3.84 2.42 4.51.27.11.51 0 .59-.29l.22-.86c.07-.28.04-.38-.15-.6-.42-.5-.69-1.15-.69-2.07 0-2.66 1.99-5.05 5.18-5.05 2.83 0 4.39 1.73 4.39 4.05 0 3.05-1.35 5.62-3.35 5.62-1.11 0-1.94-.92-1.67-2.04.32-1.34.95-2.79.95-3.76 0-.87-.47-1.59-1.43-1.59-1.14 0-2.05 1.17-2.05 2.74 0 1 .34 1.68.34 1.68l-1.37 5.8c-.41 1.73-.06 3.85-.04 4.06.01.12.17.15.24.06.1-.13 1.37-1.7 1.8-3.29l.72-2.74c.35.67 1.38 1.26 2.47 1.26 3.25 0 5.46-2.96 5.46-6.91 0-2.99-2.53-5.78-6.39-5.78Z"
      />
    </svg>
  );
};
